import React, { useEffect, useState } from 'react';
import { Header } from '../../components/Header';
import { GoBack } from '../../components/GoBack';
import { Footer } from '../../components/Footer';
import { Container } from './styles';
import api from '../../services/api';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';

export default function UseTerms() {
  const [useTerm, setUseTerm] = useState('');
  const [loading, setloading] = useState(true);
  useEffect(() => {
    async function getUseTerm() {
      await api.get(`/terms-use`).then((res) => {
        setUseTerm(res.data.text);
        setloading(false);
      });
    }
    return getUseTerm();
  }, []);
  return (
    <>
      <Header />
      <GoBack ariaLabel={'Voltar para página anterior'} title="Termos de uso" />
      <Container aria-label="Termos de uso" tabIndex={0}>
        {loading ? (
          <div style={{ height: '20vw' }}></div>
        ) : (
          <ReactMarkdown tabIndex={0}>{useTerm}</ReactMarkdown>
        )}
      </Container>
      <Footer />
    </>
  );
}
